<template>
<sidebar-widget
    :start-expanded="true"
    :sections="sections"
    :headers="[{label: 'Name'}, {label: 'Balance', classes: 'cw-6'}, {label: 'Ded. Amt', classes: 'cw-10'}]"
>
    <template v-slot:title>Miscellaneous Deductions</template>

    <template v-slot:headerbutton>
        <button class="btn btn-outline-primary" @click.prevent.stop="addModalOpen = true"><i class="far fa-plus"></i> Add</button>
    </template>

    <template v-slot:row-details="props">
        <div>
            <span>Began: </span>
            <span>{{ $filters.date(props.row.obj.created_on) }}</span>
            <br />
            <span>Added by: {{ props.row.obj.created_by?.email }}</span>
            <br />
            <span>Starting Balance: {{ $filters.dollars(props.row.obj.amount) }}</span>
            <br />
            <span>Max Per Paycheck: {{ $filters.dollars(props.row.obj.max_paycheck_amount) }}</span>
            <br />
            <span>Amount Paid: {{ $filters.dollars(props.row.obj.amount_paid) }}</span>

            <button-row v-if="props.row.obj.is_active">
                <button class="btn btn-outline-primary" @click.prevent="removeDeduction(props.row.obj.id)"><i class="far fa-trash"></i> Delete</button>

                <button class="btn btn-outline-primary" @click.prevent="currentDeductionId = props.row.obj.id; editModalOpen = true"><i class="far fa-pen"></i> Edit</button>
            </button-row>
        </div>
    </template>

    <template v-slot:extra>
        <deductions-modal
            v-if="addModalOpen || editModalOpen"
            :deduction="currentDeduction"
            :client="client"
            :employee="employee"
            :client-deduction-types="clientDeductionTypes"
            @close="currentDeductionId = null; addModalOpen = editModalOpen = false"
            @updated="$emit('updated'); getData()"
        />
    </template>
</sidebar-widget>

</template>

<script>
import SidebarWidget from '@/components/SidebarWidget'
import ButtonRow from '@/components/ButtonRow'
import DeductionsModal from './MiscDeductionsModal'

export default {
    props: ['employee', 'client', 'clientDeductionTypes', ],
    components: {SidebarWidget, ButtonRow, DeductionsModal, },
    computed: {
        sections() {
            const activeRows = []
            const inactiveRows = []

            this.employee.misc_deductions.forEach(d => {
                if (d.company_deduction_type.deduction_type.category == 'retirement-loan') {
                    return
                }

                let row = {
                    obj: d,
                    cells: [
                        d.company_deduction_type.name,
                        this.$filters.dollars(d.current_balance),
                        this.$filters.dollars(d.max_paycheck_amount) + '/pay period'
                    ],
                    id: d.id,
                }
                if (d.is_active) {
                    activeRows.push(row)
                } else {
                    inactiveRows.push(row)
                }
            })
            return [
                {title: 'Active', rows: activeRows, startExpanded: true},
                {title: 'Inactive', rows: inactiveRows, startExpanded: false},
            ]
        },
        currentDeduction() {
            if (this.currentDeductionId) {
                return this.employee.misc_deductions.find(j => j.id == this.currentDeductionId)
            }
            return undefined
        },
    },
    data() {
        return {
            addModalOpen: false,
            editModalOpen: false,
            removeModalOpen: false,
            currentDeductionId: null,
        }
    },
    mounted() {
        this.getData(true)
    },
    methods: {
        removeDeduction(deductionId) {
            if (confirm('Are you sure?')) {
                this.$store.dispatch('START_LOADING')
                const data = {
                    active_status: 'inactive',
                }

                return this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/misc-deductions/${deductionId}`, data).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showInfo('Successfully removed deduction.')
                    this.$emit('updated')
                    this.getData()
                }).catch(errors => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            }
        },
        getData(silent) {}
    },
}
</script>
